import script from "./ChangeBasket.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeBasket.vue?vue&type=script&setup=true&lang=ts"

import "./ChangeBasket.vue?vue&type=style&index=0&id=5e3c764b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e3c764b"]])

export default __exports__